import React from 'react';
import { useLanguage } from './LanguageContext';
import './LanguageToggle.css';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      className="language-toggle"
      onClick={toggleLanguage}
      aria-label={`Switch to ${language === 'en' ? 'Spanish' : 'English'}`}
      title={language === 'en' ? 'Cambiar a Español' : 'Switch to English'}
    >
      <span className={`language-option ${language === 'en' ? 'active' : 'lang-inactive'}`}>
        EN
      </span>
      <span className="language-divider">/</span>
      <span className={`language-option ${language === 'es' ? 'active' : 'lang-inactive'}`}>
        ES
      </span>
    </button>
  );
};

export default LanguageToggle;
